/** Strings for the legal pages (terms, privacy, cookies) — niup-legal-page. */
export const legal = {
  // Page shell shared by all legal documents.
  page: {
    description: 'Please review the information below carefully.',
  },
  // Tab labels (also reused as the page header title per document).
  tabs: {
    terms: 'Terms & Conditions',
    privacy: 'Privacy policy',
    cookies: 'Cookies policy',
  },
};
